.container {
  position: relative;

  display: flex;
  align-items: center;

  background-color: var(--tekhelet-purple-40);
  padding: 1rem;
  text-align: center;
  color: var(--color-text-light-solid);
}

.text {
  width: 100%;
  color: var(--color-text-light-solid);

  &::selection {
    background-color: var(--tekhelet-purple-20);
  }

  & strong {
    color: var(--color-text-light-solid);
  }
}

.button {
  position: absolute;
  right: 1rem;

  svg {
    transition: 0.2s;
  }

  &:hover {
    background-color: var(--tekhelet-purple-40);

    svg {
      filter: brightness(0.8);
    }
  }
}
